export * from './Parser.js';
export type { SparqlContext } from '@traqula/rules-sparql-1-1';
